import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  RadiosIcon,
  RadiosFireIcon,
  RadiosPoliceIcon,
  XCloseIcon,
} from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { formatTimestamp } from '../EventPane/tabs/TranscriptTab/TranscriptViewer/TranscriptViewer';
import { hideRadioPane } from '../EventPane/tabs/radiosSlice';
import { CloseButton, StyledTimestamp } from './RadiosPane.styles';

const IconPill = styled(Box).attrs(({ alertType = '' }) => {
  let color = '';
  if (alertType === 'fire') {
    color = '#FFA25F';
  } else if (alertType === 'police') {
    color = 'primaryBaseC2';
  }

  return {
    width: '23px',
    height: '23px',
    borderRadius: '4px',
    bg: color,
    mr: '8px',
    justify: 'center',
    align: 'center',
  };
})``;

const StyledRadioChannel = styled(Box).attrs({
  p: '16px 24px',
  cursor: 'pointer',
  bg: 'background',
  color: 'primaryText',
})`
  &:hover {
    background: ${({ theme }) => theme.colors.tabHighlight};
  }
`;

const RadioChannel = ({ radio = {}, onClick = () => {} }) => {
  let AlertIcon = <></>;
  if (radio.alertType === 'fire') {
    AlertIcon = <RadiosFireIcon />;
  } else if (radio.alertType === 'police') {
    AlertIcon = <RadiosPoliceIcon />;
  }

  const handleClick = () => {
    onClick(radio);
  };

  return (
    <StyledRadioChannel onClick={handleClick}>
      <Box horizontal justify="space-between">
        <Box horizontal align="center">
          <IconPill alertType={radio.alertType}>{AlertIcon}</IconPill>
          <Text fontWeight="bold">{radio.name}</Text>
        </Box>
        {radio.timestamp && (
          <StyledTimestamp>{formatTimestamp(radio.timestamp)}</StyledTimestamp>
        )}
      </Box>
      <Box mt="4px">
        <Text size="normal">{radio.message}</Text>
      </Box>
    </StyledRadioChannel>
  );
};

const RadioChannels = ({
  radios = [
    {
      id: 2,
      name: 'Police District #2',
      alertType: 'police',
      timestamp: '2024-12-01T00:10:00Z',
      message: 'User: Control what time did this get called in?',
    },
    {
      id: 1,
      name: 'Police District #1',
      alertType: 'police',
      timestamp: '2024-12-01T00:20:00Z',
      message: 'User: Control what time did this get called in?',
    },
    {
      id: 3,
      name: 'Fire District #1',
      alertType: 'fire',
      timestamp: '2024-12-01T00:30:00Z',
      message: 'User: Control what time did this get called in?',
    },
    {
      id: 4,
      name: 'Fire District #2',
      alertType: 'fire',
      timestamp: '2024-12-01T00:40:00Z',
      message: 'User: Control what time did this get called in?',
    },
    {
      id: 5,
      name: 'Police District #3',
      alertType: 'police',
      timestamp: '2024-12-01T00:50:00Z',
      message: 'User: Control what time did this get called in?',
    },
    {
      id: 6,
      name: 'Police District #4',
      alertType: 'police',
      timestamp: '2024-12-01T00:58:00Z',
      message: 'User: Control what time did this get called in?',
    },
  ],
  onRadioSelection = () => {},
}) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(hideRadioPane());
  };
  return (
    <Box>
      <Box horizontal justify="space-between" p="16px 24px 8px 24px">
        <Text color="primaryText" fontWeight="semibold" size="normal">
          <Box horizontal verticalAlign="center" color="primaryText">
            <Box mr="4px">
              <RadiosIcon width={14} height={14} />
            </Box>
            Radio Channels
          </Box>
        </Text>
        <Text color="primaryText">
          <CloseButton onClick={handleClose}>
            <XCloseIcon />
          </CloseButton>
        </Text>
      </Box>
      {radios.map(radio => (
        <RadioChannel key={radio.id} radio={radio} onClick={onRadioSelection} />
      ))}
    </Box>
  );
};

export default RadioChannels;
